import { render, staticRenderFns } from "./RankingPesca.vue?vue&type=template&id=6718a024"
import script from "./RankingPesca.vue?vue&type=script&lang=js"
export * from "./RankingPesca.vue?vue&type=script&lang=js"
import style0 from "./RankingPesca.vue?vue&type=style&index=0&id=6718a024&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports